'use client';

import { MoveRightIcon } from 'lucide-react';

import { Link } from '@/components/Link/Link';
import { href } from '@/lib/links-fields';
import { useBookDemoTrackingHandler } from '@/lib/tracking/useBookDemoTrackingHandler';
import type { InlineCardsBlock, LinkField } from '@/types';
import { ButtonLink } from '@/ui/Button/ButtonLink';

import styles from './Card.module.scss';

export function TrackedLink({
    link,
    layout,
}: {
    link: LinkField;
    layout?: InlineCardsBlock['layout'];
}) {
    const handleClick = useBookDemoTrackingHandler(link);
    const isRegularLink = layout !== 'cards' || !link.mode || link.mode === 'default';
    const shouldOpenInNewTab = link.newTab ?? false;

    return isRegularLink ? (
        <Link
            href={href(link)}
            className={styles.link}
            onClick={handleClick}
            shouldOpenInNewTab={shouldOpenInNewTab}
        >
            <span>{link.label ?? 'Read more'}</span>
            <MoveRightIcon className={styles.arrow} />
        </Link>
    ) : (
        <ButtonLink
            className={styles.button}
            href={href(link)}
            size="default"
            onClick={handleClick}
            // @ts-expect-error
            variant={link.mode ?? undefined}
            shouldOpenInNewTab={shouldOpenInNewTab}
            iconRight={MoveRightIcon}
        >
            {link.label}
        </ButtonLink>
    );
}
